module.exports = __webpack_public_path__ + "img/escriba.cccc4618.png";